import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Formik } from "formik";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";

import { OIAgricultureIncomeDetailsForm, OIAgricultureLandDetailsForm } from "..";
import { IAgriculturalIncomes } from "../../../../config/interfaces";
import {
  AgriculturalIncomeFormInitValues,
  AgriculturalIncomeFormValidationSchema
} from "../../../../pages/itr-filing/efiling.config";
import { useAppSelector } from "../../../../redux/Store";
import { ITRFilingSelector } from "../../../../redux/slice/ITRFilingSlice";
import FASvgIcon from "../../../FASvgIcon";
import ScrollToFirstError from "../../../ScrollToFirstError";

type Props = {
  showCanvas: boolean;
  formValues: IAgriculturalIncomes | null;
  handleCloseBtnPress: (salaryData: IAgriculturalIncomes | null) => void;
};

const OIAgriculturalIncomeDetailsForm: React.FC<Props> = (props: Props) => {
  const { showCanvas, handleCloseBtnPress, formValues } = props;

  const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);

  const [initFormValues, setInitFormValues] = useState<IAgriculturalIncomes>(
    AgriculturalIncomeFormInitValues
  );

  useEffect(() => {
    if (showCanvas && formValues) {
      setInitFormValues(() => cloneDeep(formValues));
    } else {
      setInitFormValues(() => cloneDeep(AgriculturalIncomeFormInitValues));
    }
  }, [showCanvas, formValues]);

  return (
    <>
      <Offcanvas show={showCanvas} placement="end" backdrop={true}>
        <Formik
          enableReinitialize={true}
          initialValues={initFormValues}
          validationSchema={AgriculturalIncomeFormValidationSchema}
          onSubmit={(values) => handleCloseBtnPress(values)}
        >
          {({ handleSubmit, submitCount, isValid, errors }) => (
            <>
              <ScrollToFirstError submitCount={submitCount} isValid={isValid} errors={errors} />

              <Offcanvas.Header>
                <Offcanvas.Title>Agricultural Income details</Offcanvas.Title>
                <Button
                  variant="primary"
                  className="icon-only hide-offcanvas"
                  onClick={() => handleCloseBtnPress(null)}
                >
                  <FASvgIcon icon={faXmark} />
                </Button>
              </Offcanvas.Header>

              <Offcanvas.Body>
                <OIAgricultureIncomeDetailsForm />
                <OIAgricultureLandDetailsForm />
              </Offcanvas.Body>

              <div className="offcanvas-btns">
                {!isFilingReadOnly ? (
                  <Button variant="outline-white" size="sm" onClick={() => handleSubmit()}>
                    Save and Close
                  </Button>
                ) : (
                  <Button
                    variant="outline-white"
                    size="sm"
                    onClick={() => handleCloseBtnPress(null)}
                  >
                    Close
                  </Button>
                )}
              </div>
            </>
          )}
        </Formik>
      </Offcanvas>
    </>
  );
};

export default OIAgriculturalIncomeDetailsForm;
